import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Clock4, Star, PlayCircle } from 'lucide-react';
import { hero, stats } from '../mock/mock';

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-[var(--rs-cream)]">
      {/* decorative blob */}
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-[var(--rs-sand)] opacity-60 blur-3xl pointer-events-none" />
      <div className="absolute top-1/3 -left-40 w-[380px] h-[380px] rounded-full bg-[var(--rs-green2)]/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-14 lg:pt-20 pb-16 lg:pb-24 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 fade-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-[#E7E0D2] text-xs text-[var(--rs-green)]">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--rs-coral)]" /> Trusted by 480+ UK letting agencies
            </div>

            <h1 className="h-display text-5xl md:text-6xl lg:text-[5.4rem] leading-[1.02] mt-5 text-[var(--rs-ink)]">
              Outsourced property services that <em className="text-[var(--rs-coral)] not-italic">actually</em> give you your week back.
            </h1>

            <p className="mt-6 text-lg text-[var(--rs-ink)]/75 max-w-2xl">
              Check-in and check-out inventories, viewings, photography and floor plans — delivered by vetted UK professionals.
              One partner, one invoice, zero excuses.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link to="/contact" className="btn-primary">Contact us <ArrowRight className="w-4 h-4" /></Link>
              <Link to="/services" className="btn-ghost">
                <PlayCircle className="w-4 h-4" /> See what we cover
              </Link>
            </div>

            <div className="mt-8" />
          </div>

          <div className="lg:col-span-5 fade-up-d1 relative">
            <div className="relative">
              <img src={hero.image} alt="UK residential property" className="w-full h-[460px] lg:h-[560px] object-cover rounded-[28px] shadow-2xl" />
              {/* floating card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-xl w-[260px] border border-[#ECE6D8]">
                <div className="text-xs uppercase tracking-widest text-[var(--rs-green)]">Today • 14:32</div>
                <div className="mt-1 font-semibold text-[var(--rs-ink)]">Check-out completed</div>
                <div className="text-sm text-[var(--rs-ink)]/65">Flat 4, 22 Elm Court, SW6 — report uploaded</div>
                <div className="mt-3 flex items-center justify-between text-xs">
                  <span className="text-[var(--rs-green)] font-medium">Inventory clerk: Sam D.</span>
                  <span className="text-[var(--rs-coral)]">View ↗</span>
                </div>
              </div>
              {/* small floating image */}
              <img src={hero.side} alt="" className="hidden md:block absolute -top-6 -right-6 w-[180px] h-[180px] object-cover rounded-2xl shadow-xl border-4 border-[var(--rs-cream)]" />
            </div>
          </div>
        </div>

        {/* stats */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-10 border-t border-[#E7E0D2] pt-10">
          {stats.map((s, i) => (
            <div key={i} className="fade-up" style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="h-display text-4xl md:text-5xl text-[var(--rs-ink)]">{s.value}</div>
              <div className="text-sm text-[var(--rs-ink)]/65 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* partners marquee removed */}
    </section>
  );
};

export default Hero;
